var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 219,
    height: 73,
    viewBox: "0 0 219 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31394b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_365",
    x: 0,
    y: 0,
    width: 219,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40063",
    "data-name": "Group 40063",
    transform: "translate(-703 -550)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40059",
    "data-name": "Group 40059",
    transform: "translate(7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BTn_Primary",
    transform: "translate(705.199 555.654)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.2, -5.65)",
    filter: "url(#Rectangle_365)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365-2",
    "data-name": "Rectangle 365",
    width: 201,
    height: 55,
    rx: 8,
    transform: "translate(9 6)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_logo__2012_2_",
    "data-name": "Microsoft_logo_(2012) (2)",
    transform: "translate(740 570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80953",
    "data-name": "Path 80953",
    d: "M111.76,12.438V29.144h-2.9V16.034h-.039l-5.182,13.11h-1.934l-5.3-13.11h-.039v13.11H93.7V12.438h4.177l4.8,12.375h.077l5.066-12.375h3.945Zm2.4,1.276a1.471,1.471,0,0,1,.5-1.16,1.729,1.729,0,0,1,1.2-.464,1.693,1.693,0,0,1,1.238.464,1.608,1.608,0,0,1,.5,1.16,1.471,1.471,0,0,1-.5,1.16,1.757,1.757,0,0,1-1.238.464,1.6,1.6,0,0,1-1.2-.464A1.751,1.751,0,0,1,114.158,13.714Zm3.133,3.442V29.144h-2.823V17.156h2.823Zm8.547,9.939a3.258,3.258,0,0,0,1.392-.309,6.109,6.109,0,0,0,1.392-.773v2.63a4.934,4.934,0,0,1-1.547.58,9.516,9.516,0,0,1-1.895.193,5.681,5.681,0,0,1-4.293-1.663,5.771,5.771,0,0,1-1.663-4.254,6.824,6.824,0,0,1,1.7-4.757,6.122,6.122,0,0,1,4.8-1.856,7.118,7.118,0,0,1,1.586.193,5.27,5.27,0,0,1,1.276.464V20.25a5.618,5.618,0,0,0-1.315-.735,4.443,4.443,0,0,0-1.392-.271,3.527,3.527,0,0,0-2.707,1.083,4.057,4.057,0,0,0-1.006,2.939,3.87,3.87,0,0,0,1.006,2.823A3.617,3.617,0,0,0,125.837,27.095Zm10.79-10.132a3.126,3.126,0,0,1,.619.039,4.014,4.014,0,0,1,.464.116v2.862a1.736,1.736,0,0,0-.657-.309,3.968,3.968,0,0,0-1.044-.155,2.162,2.162,0,0,0-1.74.889,4.271,4.271,0,0,0-.735,2.707v6.033H130.71V17.156h2.823v1.895h.039a3.643,3.643,0,0,1,1.16-1.547A3.408,3.408,0,0,1,136.627,16.962Zm1.238,6.381a6.68,6.68,0,0,1,1.663-4.718,6.153,6.153,0,0,1,4.641-1.74,5.685,5.685,0,0,1,4.37,1.663,6.385,6.385,0,0,1,1.586,4.525,6.549,6.549,0,0,1-1.663,4.641,6.032,6.032,0,0,1-4.563,1.74,5.957,5.957,0,0,1-4.409-1.624A6.206,6.206,0,0,1,137.865,23.343Zm2.939-.116a4.217,4.217,0,0,0,.851,2.862,3.091,3.091,0,0,0,2.436,1.005,2.815,2.815,0,0,0,2.359-1.005,4.517,4.517,0,0,0,.812-2.939,4.664,4.664,0,0,0-.812-2.939,3.228,3.228,0,0,0-4.718.039A4.237,4.237,0,0,0,140.8,23.227Zm13.536-2.9a1.227,1.227,0,0,0,.387.967,6.615,6.615,0,0,0,1.7.851,5.9,5.9,0,0,1,2.359,1.508,3.133,3.133,0,0,1,.7,2.05,3.247,3.247,0,0,1-1.315,2.707,5.443,5.443,0,0,1-3.519,1.005,9.162,9.162,0,0,1-1.663-.193,6.692,6.692,0,0,1-1.547-.464V25.973a6.757,6.757,0,0,0,1.663.851,5.213,5.213,0,0,0,1.624.309,2.6,2.6,0,0,0,1.392-.271.949.949,0,0,0,.464-.889,1.361,1.361,0,0,0-.464-1.006,7.142,7.142,0,0,0-1.779-.928,5.319,5.319,0,0,1-2.2-1.47,3.514,3.514,0,0,1,.619-4.757,5.108,5.108,0,0,1,3.326-1.044,6.132,6.132,0,0,1,1.392.155c.5.116.967.232,1.315.348v2.746a8.33,8.33,0,0,0-1.315-.657,4.093,4.093,0,0,0-1.47-.271,2.156,2.156,0,0,0-1.238.309A1.235,1.235,0,0,0,154.339,20.327Zm6.342,3.016a6.68,6.68,0,0,1,1.663-4.718,6.153,6.153,0,0,1,4.641-1.74,5.685,5.685,0,0,1,4.37,1.663,6.385,6.385,0,0,1,1.586,4.525,6.55,6.55,0,0,1-1.663,4.641,6.032,6.032,0,0,1-4.563,1.74,5.957,5.957,0,0,1-4.409-1.624A6.374,6.374,0,0,1,160.682,23.343Zm2.939-.116a4.217,4.217,0,0,0,.851,2.862,3.091,3.091,0,0,0,2.436,1.005,2.815,2.815,0,0,0,2.359-1.005,4.517,4.517,0,0,0,.812-2.939,4.664,4.664,0,0,0-.812-2.939,3.228,3.228,0,0,0-4.718.039A4.428,4.428,0,0,0,163.621,23.227Zm18.718-3.751h-4.215v9.668h-2.862V19.476h-2.011v-2.32h2.011V15.493a4.171,4.171,0,0,1,4.37-4.293c.348,0,.657.039.928.039a1.847,1.847,0,0,1,.7.155V13.83a4.739,4.739,0,0,0-.5-.193,2.571,2.571,0,0,0-.812-.116,1.745,1.745,0,0,0-1.354.541,2.466,2.466,0,0,0-.464,1.624v1.431h4.215V14.41l2.823-.851v3.558h2.862v2.32h-2.862v5.608a2.574,2.574,0,0,0,.387,1.547,1.61,1.61,0,0,0,1.276.464,1.909,1.909,0,0,0,.58-.116,2.021,2.021,0,0,0,.58-.271v2.32a2.7,2.7,0,0,1-.889.271,6.7,6.7,0,0,1-1.238.116,3.494,3.494,0,0,1-2.668-.928,4.088,4.088,0,0,1-.889-2.862l.039-6.11Z",
    transform: "translate(-57.463 -6.869)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40058",
    "data-name": "Group 40058"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    width: 13.226,
    height: 13.226,
    fill: "#f25022"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 13.226,
    height: 13.226,
    transform: "translate(14.618)",
    fill: "#7fba00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 13.226,
    height: 13.226,
    transform: "translate(0 14.618)",
    fill: "#00a4ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 13.226,
    height: 13.226,
    transform: "translate(14.618 14.618)",
    fill: "#ffb900"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogin);
export default __webpack_public_path__ + "static/media/MicrosoftLogin.3d50a84f6df73f54a4fbb3e9066a2dbd.svg";
export { ForwardRef as ReactComponent };